import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PageTitleService implements OnDestroy  {
  public title: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  setTitle(value: string) {
    this.title.next(value);
  }

  public ngOnDestroy(): void {
    // No manual unsubscribe needed when using takeUntilDestroyed
  }
}